export const ExperimentNames = {
  // Forever experiment
  UseWarmupState: 'specs.events.ui.UseWarmupState',
  EventDetailsSlots: 'specs.events.ui.EventDetailsSlots',
  EventDetailsSlotsViewer: 'specs.events.ui.EventDetailsSlotsViewer',
  DashboardSlots: 'specs.events.ui.DashboardSlots',
  ExpressCheckout: 'specs.events.ui.ExpressCheckout',
  PaymentsStyleApi: 'specs.events.ui.PaymentsStyleApi',
  UpdatePaymentMethodEnabled: 'specs.events.ui.UpdatePaymentMethodEnabled', // Disables fees on offline payment, disable to prevent order update on paymentMethod change.

  SausageIntegration: 'specs.events.ui.SausageIntegration', // false 100%, 2024-11-08
  UpdatePaymentTermsPaypal: 'specs.events.ui.UpdatePaymentTermsPaypal',
  AiEventsAssistantV2: 'specs.events.ui.AiEventsAssistantV2',
  AiEventsQaAssistant: 'specs.events.ui.AiEventsQaAssistant',
  AiTicketsAssistant: 'specs.events.ui.AiTicketsAssistant',
  AiTicketsQaAssistant: 'specs.events.ui.AiTicketsQaAssistant',

  AiEventsListQaAssistant: 'specs.events.ui.AiEventsListQaAssistant',
  AiChangeEventTypeAssistant: 'specs.events.ui.AiChangeEventTypeAssistant',
  AiOnlineEventQaAssistant: 'specs.events.ui.AiOnlineEventQaAssistant',
  AiDetailsPageStyleQaAssistant: 'specs.events.ui.AiDetailsPageStyleQaAssistant',
  AiCheckInAppQaAssistant: 'specs.events.ui.AiCheckInAppQaAssistant',
  AiAddStaffMemberAssistant: 'specs.events.ui.AiAddStaffMemberAssistant',

  CurvedMultiRowAnnouncement: 'specs.seatings.ui.CurvedMultiRowAnnouncement',
  AutomationV3Enabled: 'automations.SiteOnV3AutomationsBuilder',
  OfferExpressCheckout: 'specs.events.ui.OfferExpressCheckout',
  WidgetSEOTags: 'specs.events.ui.WidgetSEOTags',
  CategoryTabsUoU: 'specs.events.ui.CategoryTabsUoU',
  CategoryMenuSettings: 'specs.events.ui.CategoryMenuSettings',
  DelayedPayments: 'specs.events.ui.DelayedPaymentCapture',
  AutomationsBanner: 'specs.events.ui.AutomationsBanner',
  AiCopyTicketsAssistant: 'specs.events.ui.AiCopyTicketsAssistant',
  SkillTicketPolicy: 'specs.events.ui.SkillTicketPolicy',
  ImageRatioAssistant: 'specs.events.ui.ImageRatioAssistant',
  AiCreateCategoryAssistant: 'specs.events.ui.AiCreateCategoryAssistant',
  AiCategoriesQaAssistant: 'specs.events.ui.AiCategoriesQaAssistant',
  SkillMembershipsQA: 'specs.events.ui.SkillMembershipsQA',
  AiGuestsAndOrdersQaAssistant: 'specs.events.ui.AiGuestsAndOrdersQaAssistant',
  AiCreateScheduleItemAssistant: 'specs.events.ui.AiCreateScheduleItemAssistant',
  AiCreateRegistrationFormFieldAssistant: 'specs.events.ui.AiCreateRegistrationFormFieldAssistant',
  AiPromotionsAssistant: 'specs.events.ui.PromotionsAssistantQA',
  GuestManagement: 'specs.events.ui.GuestManagement',
  SkillSeatingQA: 'specs.seatings.ui.SkillSeatingQA',
  EventsListSeoPanel: 'specs.events.ui.EventsListSeoPanel',
  FeaturedEventWidget: 'specs.events.ui.FeaturedEventWidget',
  DisableRicosImageGeneration: 'specs.events.ui.DisableRicosImageGeneration',
  UpdatedDisplayListEventsPanel: 'specs.events.ui.UpdatedDisplayListEventsPanel',
  FixCancelReservation: 'specs.events.ui.FixCancelReservation',
  ResponsiveCards: 'specs.events.ui.ResponsiveCards',
  NewClassicEvents: 'se_eventsCategoryNewContentInAddPanel', // Add panel
  SettingsWDSMigration: 'specs.events.ui.SettingsWDSMigration',
  UpdateRichContentTruncate: 'specs.events.ui.UpdateRichContentTruncate',
  HideWidgetTypeSelect: 'specs.events.ui.HideWidgetTypeSelect',
  NavigateToCheckoutWithReservationId: 'specs.events.ui.NavigateToCheckoutWithReservationId',
  UpdatedEmptyState: 'specs.events.ui.UpdatedEmptyState',
  AccessibilityLocalization: 'specs.events.ui.AccessibilityLocalization',
  ConsistentGuests: 'specs.events.ui.ConsistentGuests',
  DelayedCancelReservation: 'specs.events.ui.DelayedCancelReservation',
  BulkGuestRemove: 'specs.events.ui.BulkGuestRemove',
  NewFirstTimeExperience: 'specs.events.ui.NewFirstTimeExperience',
  UpdateTicketedGuestPrice: 'specs.events.ui.UpdateTicketedGuestPrice',
  SoldSeatsOnLoadWarning: 'specs.seatings.ui.SoldSeatsOnLoadWarning',
  NewCreateEventImageCard: 'specs.events.ui.NewCreateEventImageCard',
  DelayPaymentModalLocalization: 'specs.events.ui.DelayPaymentModalLocalization',
  UpdatedEmptyStates: 'specs.events.ui.UpdatedEmptyStates',
  StaffReadGuestFormPermission: 'specs.events.ui.StaffReadGuestFormPermission',
  DuplicateTicketFromSeatings: 'specs.events.ui.DuplicateTicketFromSeatings',
  ViewContactEntryPoints: 'specs.events.ui.ViewContactEntryPoints',
  RenameTicketPolicy: 'specs.events.ui.RenameTicketPolicy',
  RenameTicketPolicyAI: 'specs.events.ui.RenameTicketPolicyAI',
  RelocatedPoliciesModal: 'specs.events.ui.RelocatedPoliciesModal',
  RelocatedOccurrencesModal: 'specs.events.ui.RelocatedOccurrencesModal',
  AssignTicketsOccupiedSeats: 'specs.events.ui.AssignTicketsOccupiedSeats',
  UseDetailsPageReduxToolkit: 'specs.events.ui.UseDetailsPageReduxToolkit',
  RelocatedUpgradeModal: 'specs.events.ui.RelocatedUpgradeModal',
  VistaprintEntryPoint: 'specs.events.ui.VistaprintEntryPoint',
  RelocatedPagesModal: 'specs.events.ui.RelocatedPagesModal',
  RelocatedPageInfo: 'specs.events.ui.RelocatedPageInfo',
  RelocatedGoogleMap: 'specs.events.ui.RelocatedGoogleMap',
  FixLoadMembers: 'specs.events.ui.FixLoadMembers',
  ButtonLayoutEmptyState: 'specs.events.ui.ButtonLayoutEmptyState',
  RestrictPaymentSettings: 'specs.events.ui.RestrictPaymentSettings',
  EmailsForManuallyAddedRsvps: 'specs.events.ui.EmailsForManuallyAddedRsvps',
  NavigateToEcomCheckout: 'specs.events.ui.NavigateToEcomCheckout',
  UseEventsViewerReduxToolkit: 'specs.events.ui.UseEventsViewerReduxToolkit',
  PublishSiteBanners: 'specs.events.ui.PublishSiteBanners',
  UseAmbassadorForAddSeatedGuestsManually: 'specs.events.ui.UseAmbassadorForAddSeatedGuestsManually',
  UseAmbassadorForAddGuestsManually: 'specs.events.ui.UseAmbassadorForAddGuestsManually',
  FixDetailsPageInitialNavigation: 'specs.events.ui.FixDetailsPageInitialNavigation',
  CalendarRevamp: 'specs.events.ui.CalendarRevamp',
}
